import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../auth/store/authSlice";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [fcm_token, setFcmToken] = useState(null);
  const navigate = useNavigate();

  const { loginStatus } = useSelector((state) => state?.auth);

  useEffect(() => {
    if (loginStatus === true) {
      toast.success("Login Successfull")
      navigate("/auth/chatlist");
    } 
  }, [loginStatus]);

  useEffect(() => {
    if (window.FcmTokenChannel) {
        window.FcmTokenChannel.postMessage("requestFCMToken");
    }
}, [])

    // Receive the FCM token from Flutter
   window.receiveFCMToken = function (token) {
      console.log("FCM token received", token)
      setFcmToken(token); // Store the FCM token in state
  };

  const handleLogin = () => {
    let hasError = false;

    if (!phone) {
      setPhoneError("Please enter your phone number");
      hasError = true;
    } else if (phone.length !== 10) {
      setPhoneError("Phone number must be 10 digits");
      hasError = true;
    } else {
      setPhoneError("");
    }

    if (!password) {
      setPasswordError("Please enter your password.");
      hasError = true;
    } else {
      setPasswordError("");
    }

    if (hasError) return;

    dispatch(loginUser({ password, phone,fcm_token }));
  };

  const handlePhoneInputChange = (event) => {
    const inputValue = event.target.value.replace(/\D/g, ""); 
    setPhone(inputValue);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
     <ToastContainer position="top-right" />
    <Container
      fluid
      className="d-flex vh-100 align-items-center justify-content-center bg-light"
    >
      <Card className="shadow p-4" style={{ width: "30rem" }}>
        <Card.Header className="text-center bg-white border-0">
          <h4>Login</h4>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <label className="form-label">Phone</label>
              <InputGroup>
                <FormControl
                  type="text"
                  name="phone"
                  placeholder="Enter phone number"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  maxLength={10}
                  value={phone}
                  onChange={handlePhoneInputChange}
                  onKeyPress={handleKeyPress}
                  autoFocus={true}
                />
              </InputGroup>
              {phoneError && <div className="text-danger mt-1">{phoneError}</div>}
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              {passwordError && <div className="text-danger mt-1">{passwordError}</div>}
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-center mt-3">
                <Button
                  variant="success"
                  className="w-50"
                  onClick={handleLogin}
                >
                  Login
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
    </>
  );
};

export default Login;
